export default __webpack_public_path__ + "static/media/749bec05a3007ee0cfd486445574b2171602162004770.1fbefda2.webp";